import { render, staticRenderFns } from "./SitesMonetization.vue?vue&type=template&id=10a8d7cf&scoped=true"
import script from "./SitesMonetization.vue?vue&type=script&lang=js"
export * from "./SitesMonetization.vue?vue&type=script&lang=js"
import style0 from "./SitesMonetization.vue?vue&type=style&index=0&id=10a8d7cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a8d7cf",
  null
  
)

export default component.exports